import React from "react";
import { Card, Typography, Grid } from "@mui/material";
import '../../assets/styles/agents.css';
import { capitalizeLabel } from "../../common_functions/video_annotator_functions";

const excemptionFields = ['cpu_percentage', 'disk_free_percentage', 'gpu_vram_percentage', 'ram_percentage'];

export const CustomCardGrid = ({ selectedAgentDetail }) => {
  return (
    <Grid container className="agents-detail-container" spacing={2}>
      <Grid container spacing={2} className="agent-details">
    {selectedAgentDetail && Object.keys(selectedAgentDetail).length>0 && Object.entries(selectedAgentDetail)
      .filter(([key]) => !excemptionFields.includes(key))
      .map(([key, value]) => (
        <Grid
          item
          xs={12}
          sm={6}
          md={3}
          key={key}
          sx={{ display: "flex", alignItems: "stretch" }} // Ensures uniform height
        >
          <Card
            sx={{
              padding: "16px",
              borderRadius: "12px",
              backgroundColor: "#f9f9f9",
              transition: "transform 0.2s ease-in-out",
              display: "flex",
              flexDirection: "column", // Stacks elements vertically
              justifyContent: "space-between", // Distributes content evenly
              flexGrow: 1, // Allows all cards to have equal height
              "&:hover": {
                transform: "scale(1.02)",
              },
            }}
          >
            <Typography
              sx={{ fontStyle: "none", fontSize: "1rem", fontWeight: "bold" }}
            >
              {capitalizeLabel(key)}
            </Typography>
            <Typography sx={{ fontStyle: "none", fontSize: "1rem" }}>
              {value !== null
                ? /^[0-9\b]+$/.test(value)
                  ? value.toString() + " GB"
                  : value.toString()
                : "N/A"}
            </Typography>
          </Card>
        </Grid>
      ))}
      </Grid>
  </Grid>
  
  );
};
